import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import _ from 'lodash'

import PipelineCard from 'components/PipelineCard'
import { selectPipeline } from 'store/selectors/pipeline'

const PipelineCardContainer = ({ opportunity, stageId, index, onDrop, setCurrentlyDragging }) => {
  const { results: pipelineData } = useSelector(selectPipeline)

  const [isDraggedOver, setIsDraggedOver] = useState(false)

  const ref = useRef(null)

  useEffect(() => {
    return dropTargetForElements({
      element: ref.current,
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      onDrop: ({ source }) => {
        setIsDraggedOver(false)
        onDrop({ destination: { droppableId: stageId, index }, draggableId: source.data.id })
      }
    })
  }, [pipelineData, stageId, index])

  const classes = ['Pipeline__card-container']
  if (!opportunity) classes.push('empty')
  if (isDraggedOver) classes.push('active')

  return (
    <div ref={ref} className={classes.join(' ')}>
      {opportunity && (
        <PipelineCard opportunity={opportunity} setCurrentlyDragging={setCurrentlyDragging} />
      )}
    </div>
  )
}

const PipelineStage = ({
  id: stageId,
  name,
  opportunities,
  onDrop,
  currentlyDragging,
  setCurrentlyDragging
}) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const fundersCount = opportunities.length
  const fundersPlural = fundersCount !== 1

  return (
    <>
      <h4>{name}</h4>
      <small>{`${fundersCount} ${
        fundersPlural ? t.pipeline.prospectiveFunders : t.pipeline.prospectiveFunder
      }`}</small>
      <div className={`Pipeline__column ${name}`}>
        {opportunities
          .sort((a, b) => a.pipelineStageOrder - b.pipelineStageOrder)
          .map((opportunity, index) => {
            return (
              <PipelineCardContainer
                key={opportunity.id}
                opportunity={opportunity}
                index={index}
                stageId={stageId}
                onDrop={onDrop}
                setCurrentlyDragging={setCurrentlyDragging}
              />
            )
          })}
        {currentlyDragging && (
          <PipelineCardContainer
            stageId={stageId}
            index={opportunities.length}
            onDrop={onDrop}
            setCurrentlyDragging={setCurrentlyDragging}
          />
        )}
      </div>
    </>
  )
}

export default PipelineStage
